import { render } from "./GalleryWrite.vue?vue&type=template&id=3fab31ef&scoped=true"
import script from "./GalleryWrite.vue?vue&type=script&lang=js"
export * from "./GalleryWrite.vue?vue&type=script&lang=js"

import "./GalleryWrite.vue?vue&type=style&index=0&id=3fab31ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fab31ef"]])

export default __exports__